




















// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axios from 'axios';

// const initialState = {
//   employees: [],
//   salaryHistory: [],
//   leaveRequests: [],
//   status: 'idle',
//   error: null,
// };

// export const fetchEmployees = createAsyncThunk(
//   'employerEmployee/fetchEmployees',
//   async ({ id, userType }, { rejectWithValue }) => {
//     try {
//       let response;
//       if (userType === 'jobEmployer') {
//         const employeesResponse = await axios.get(
//           `${process.env.REACT_APP_API_URL}employer-employee/employees?employerId=${id}`,
//           { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
//         );
//         if (!employeesResponse.data || employeesResponse.data.length === 0) {
//           return rejectWithValue('No employees found for this jobEmployer');
//         }
//         const employerResponse = await axios.get(
//           `${process.env.REACT_APP_API_URL}employer-employee/employer/${id}`,
//           { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
//         );
//         if (!employerResponse.data) {
//           return rejectWithValue('JobEmployer not found');
//         }
//         return { employees: employeesResponse.data, employer: employerResponse.data };
//       } else if (userType === 'jobSeeker') {
//         response = await axios.get(
//           `${process.env.REACT_APP_API_URL}employer-employee/employees/${id}`,
//           { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
//         );
//         if (!response.data || !response.data._id) {
//           return rejectWithValue('No employee data found');
//         }
//         return response.data;
//       }
//       return rejectWithValue('Invalid user type');
//     } catch (error) {
//       return rejectWithValue(error.message || 'Failed to fetch employee data');
//     }
//   }
// );

// // export const fetchEmployees = createAsyncThunk('employerEmployee/fetchEmployees', async (jobSeekerId, { rejectWithValue }) => {
// //   try {
// //     const response = await axios.get(`${process.env.REACT_APP_API_URL}employer-employee/employees/${jobSeekerId}`, {
// //       headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
// //     });
// //     if (!response.data || !response.data._id) {
// //       return rejectWithValue('No employee data found');
// //     }
// //     return response.data; 
// //   } catch (error) {
// //     return rejectWithValue(error.message || 'Failed to fetch employee');
// //   }
// // });

// export const addEmployee = createAsyncThunk('employees/addEmployee', async (data) => {
//   const response = await axios.post(`${process.env.REACT_APP_API_URL}employer-employee/add-employee/${data.employerId}`, data);
//   return response.data.employee;
// });

// export const addSalary = createAsyncThunk('employees/addSalary', async (data) => {
//   const response = await axios.post(`${process.env.REACT_APP_API_URL}employer-employee/add-salary/${data.employerId}/${data.employeeId}`, data);
//   return response.data.employee;
// });

// export const updateEmployee = createAsyncThunk('employees/updateEmployee', async (data) => {
//   const response = await axios.put(`${process.env.REACT_APP_API_URL}employer-employee/update-employee/${data.employerId}/${data.employeeId}`, data);
//   return response.data.employee;
// });

// export const deleteEmployee = createAsyncThunk('employees/deleteEmployee', async (data) => {
//   await axios.delete(`${process.env.REACT_APP_API_URL}employer-employee/delete-employee/${data.employerId}/${data.employeeId}`);
//   return data.employeeId;
// });

// export const requestLeave = createAsyncThunk('employees/requestLeave', async (data) => {
//   const response = await axios.post(`${process.env.REACT_APP_API_URL}employer-employee/request-leave/${data.employerId}/${data.employeeId}`, data);
//   return response.data.leaveRequest;
// });

// export const approveLeave = createAsyncThunk('employees/approveLeave', async (data) => {
//   const response = await axios.put(`${process.env.REACT_APP_API_URL}employer-employee/approve-leave/${data.employerId}/${data.employeeId}/${data.leaveId}`, data);
//   return response.data.leave;
// });

// export const rejectLeave = createAsyncThunk('employees/rejectLeave', async (data) => {
//   const response = await axios.put(`${process.env.REACT_APP_API_URL}employer-employee/reject-leave/${data.employerId}/${data.employeeId}/${data.leaveId}`, data);
//   return response.data.leave;
// });

// const employeeSlice = createSlice({
//   name: 'employerEmployee',
//   // name: 'employees',
//   initialState,
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchEmployees.fulfilled, (state, action) => {
//         state.employees = [action.payload]; 
//         // state.employees = action.payload;
//         state.status = 'succeeded';
//       })
      
//       .addCase(addEmployee.fulfilled, (state, action) => {
//         state.employees.push(action.payload);
//       })
//       .addCase(addSalary.fulfilled, (state, action) => {
//         const employee = state.employees.find(e => e._id === action.payload._id);
//         if (employee) Object.assign(employee.salary, action.payload.salary);
//       })
//       .addCase(updateEmployee.fulfilled, (state, action) => {
//         const index = state.employees.findIndex(e => e._id === action.payload._id);
//         if (index !== -1) state.employees[index] = action.payload;
//       })
//       .addCase(deleteEmployee.fulfilled, (state, action) => {
//         state.employees = state.employees.filter(e => e._id !== action.payload);
//       })
//       .addCase(requestLeave.fulfilled, (state, action) => {
//         const employee = state.employees.find(e => e._id === action.payload.employee);
//         if (employee) employee.leaveRequests.push(action.payload);
//       })
//       .addCase(approveLeave.fulfilled, (state, action) => {
//         const employee = state.employees.find(e => e._id === action.payload.employee);
//         if (employee) {
//           const leave = employee.leaveRequests.find(l => l._id === action.payload._id);
//           if (leave) Object.assign(leave, action.payload);
//         }
//       })
//       .addCase(rejectLeave.fulfilled, (state, action) => {
//         const employee = state.employees.find(e => e._id === action.payload.employee);
//         if (employee) {
//           const leave = employee.leaveRequests.find(l => l._id === action.payload._id);
//           if (leave) Object.assign(leave, action.payload);
//         }
//       });
//   },
// });

// export default employeeSlice.reducer;
















import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  employees: [],
  employer: null,
  salaryHistory: [],
  leaveRequests: [],
  status: 'idle',
  error: null,
};

export const fetchEmployees = createAsyncThunk(
  'employerEmployee/fetchEmployees',
  async ({ id, userType }, { rejectWithValue }) => {
    try {
      let response;
      if (userType === 'jobEmployer') {
        const employeesResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}employer-employee/employees?employerId=${id}`,
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );
        if (!employeesResponse.data || employeesResponse.data.length === 0) {
          return rejectWithValue('No employees found for this jobEmployer');
        }
        const employerResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}employer-employee/employer/${id}`,
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );
        if (!employerResponse.data) {
          return rejectWithValue('JobEmployer not found');
        }
        return { employees: employeesResponse.data, employer: employerResponse.data };
      } else if (userType === 'jobSeeker') {
        response = await axios.get(
          `${process.env.REACT_APP_API_URL}employer-employee/employees/${id}`,
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );
        if (!response.data || !response.data._id) {
          return rejectWithValue('No employee data found');
        }
        return response.data;
      }
      return rejectWithValue('Invalid user type');
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch employee data');
    }
  }
);

export const addEmployee = createAsyncThunk('employees/addEmployee', async (data) => {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}employer-employee/add-employee/${data.employerId}`, data);
  return response.data.employee;
});

export const addSalary = createAsyncThunk('employees/addSalary', async (data) => {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}employer-employee/add-salary/${data.employerId}/${data.employeeId}`, data);
  return response.data.employee;
});

export const updateEmployee = createAsyncThunk('employees/updateEmployee', async (data) => {
  const response = await axios.put(`${process.env.REACT_APP_API_URL}employer-employee/update-employee/${data.employerId}/${data.employeeId}`, data);
  return response.data.employee;
});

export const deleteEmployee = createAsyncThunk('employees/deleteEmployee', async (data) => {
  await axios.delete(`${process.env.REACT_APP_API_URL}employer-employee/delete-employee/${data.employerId}/${data.employeeId}`);
  return data.employeeId;
});

export const requestLeave = createAsyncThunk('employees/requestLeave', async (data) => {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}employer-employee/request-leave/${data.employerId}/${data.employeeId}`, data);
  return response.data.leaveRequest;
});

export const approveLeave = createAsyncThunk('employees/approveLeave', async (data) => {
  const response = await axios.put(`${process.env.REACT_APP_API_URL}employer-employee/approve-leave/${data.employerId}/${data.employeeId}/${data.leaveId}`, data);
  return response.data.leave;
});

export const rejectLeave = createAsyncThunk('employees/rejectLeave', async (data) => {
  const response = await axios.put(`${process.env.REACT_APP_API_URL}employer-employee/reject-leave/${data.employerId}/${data.employeeId}/${data.leaveId}`, data);
  return response.data.leave;
});

const employeeSlice = createSlice({
  name: 'employerEmployee',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployees.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchEmployees.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (action.payload.employees) {
          state.employees = action.payload.employees;
          state.employer = action.payload.employer;
          // Assuming salaryHistory and leaveRequests are nested in employees
          state.salaryHistory = action.payload.employees.flatMap(employee =>
            employee.salary ? employee.salary.history || [] : []
          );
          state.leaveRequests = action.payload.employees.flatMap(employee =>
            employee.leaveRequests || []
          );
        } else {
          state.employees = [action.payload];
          state.salaryHistory = action.payload.salary ? action.payload.salary.history || [] : [];
          state.leaveRequests = action.payload.leaveRequests || [];
        }
      })
      .addCase(fetchEmployees.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(addEmployee.fulfilled, (state, action) => {
        state.employees.push(action.payload);
      })
      .addCase(addSalary.fulfilled, (state, action) => {
        const employee = state.employees.find(e => e._id === action.payload._id);
        if (employee) {
          Object.assign(employee.salary, action.payload.salary);
          state.salaryHistory = state.employees.flatMap(e => e.salary ? e.salary.history || [] : []);
        }
      })
      .addCase(updateEmployee.fulfilled, (state, action) => {
        const index = state.employees.findIndex(e => e._id === action.payload._id);
        if (index !== -1) {
          state.employees[index] = action.payload;
          state.salaryHistory = state.employees.flatMap(e => e.salary ? e.salary.history || [] : []);
          state.leaveRequests = state.employees.flatMap(e => e.leaveRequests || []);
        }
      })
      .addCase(deleteEmployee.fulfilled, (state, action) => {
        state.employees = state.employees.filter(e => e._id !== action.payload);
        state.salaryHistory = state.employees.flatMap(e => e.salary ? e.salary.history || [] : []);
        state.leaveRequests = state.employees.flatMap(e => e.leaveRequests || []);
      })
      .addCase(requestLeave.fulfilled, (state, action) => {
        const employee = state.employees.find(e => e._id === action.payload.employee);
        if (employee) {
          employee.leaveRequests = employee.leaveRequests || [];
          employee.leaveRequests.push(action.payload);
          state.leaveRequests = state.employees.flatMap(e => e.leaveRequests || []);
        }
      })
      .addCase(approveLeave.fulfilled, (state, action) => {
        const employee = state.employees.find(e => e._id === action.payload.employee);
        if (employee) {
          const leave = employee.leaveRequests.find(l => l._id === action.payload._id);
          if (leave) Object.assign(leave, action.payload);
          state.leaveRequests = state.employees.flatMap(e => e.leaveRequests || []);
        }
      })
      .addCase(rejectLeave.fulfilled, (state, action) => {
        const employee = state.employees.find(e => e._id === action.payload.employee);
        if (employee) {
          const leave = employee.leaveRequests.find(l => l._id === action.payload._id);
          if (leave) Object.assign(leave, action.payload);
          state.leaveRequests = state.employees.flatMap(e => e.leaveRequests || []);
        }
      });
  },
});

export default employeeSlice.reducer;